import { useCallback } from 'react';
import { useRouter } from 'next/router';
import queryString from 'query-string';
import { InboxPageMobileView } from '../types/InboxPageMobileView';
import useWindowSize from './useWindowSize';
import type { SatelliteConversationFolderTypeV2 } from '@zg-rentals/ts-satellite-client';
import type { ChangeRouteArgs } from '../types/ChangeRouteArgs';

type ChangeFiltersArgs = {
  folder?: SatelliteConversationFolderTypeV2;
  isMobile?: boolean;
  mobileViewToChangeTo?: string;
};

export default () => {
  const { isMobileView } = useWindowSize();
  const router = useRouter();

  const getFilteredQueryString = useCallback(
    ({ folder, isMobile, mobileViewToChangeTo }: ChangeFiltersArgs): string => {
      const paramsObj: Record<string, string> = {};

      if (folder) {
        paramsObj.folder = folder;
      }

      if (isMobile || isMobileView) {
        paramsObj.mobileView = mobileViewToChangeTo || InboxPageMobileView.ConversationList;
      }

      return Object.keys(paramsObj).length > 0 ? `?${queryString.stringify(paramsObj)}` : '';
    },
    [isMobileView],
  );

  const changeRoute = useCallback(
    ({
      selectedOption,
      conversationIdToRedirectTo,
      mobileViewToChangeTo = InboxPageMobileView.ConversationList,
      isMobile,
    }: ChangeRouteArgs) => {
      const filtersQueryString = getFilteredQueryString({
        folder: selectedOption,
        isMobile,
        mobileViewToChangeTo,
      });
      const parsedQuery = queryString.parse(filtersQueryString);
      const conversationId = conversationIdToRedirectTo ? [conversationIdToRedirectTo] : [];

      const updatedRouter = {
        pathname: router.pathname,
        query: {
          ...router.query,
          ...parsedQuery,
          conversationId,
        },
      };
      router.push(updatedRouter, undefined, { scroll: false });
    },
    [router, getFilteredQueryString],
  );

  return {
    changeRoute,
    getFilteredQueryString,
  };
};
